import { render } from "./ToggleNavbar.vue?vue&type=template&id=8481d54e&scoped=true"
import script from "./ToggleNavbar.vue?vue&type=script&lang=js"
export * from "./ToggleNavbar.vue?vue&type=script&lang=js"

import "./ToggleNavbar.vue?vue&type=style&index=0&id=8481d54e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8481d54e"]])

export default __exports__